export const ARTICLE_COVER_IMAGE_BUCKET = "articles-covers";
export const EVENT_COVER_IMAGE_BUCKET = "events-covers";
export const PLACE_COVER_IMAGE_BUCKET = "places-covers";
export const TAXONOMY_ICON_BUCKET = "taxonomy-icons";

export const ARTICLE_COVER_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
export const TAXONOMY_ICON_MAX_BYTES = 100 * 1024;

export const ARTICLE_COVER_IMAGE_ACCEPTED_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
] as const;

export const TAXONOMY_ICON_ACCEPTED_TYPES = ["image/svg+xml"] as const;

export type ArticleCoverImageMimeType =
  (typeof ARTICLE_COVER_IMAGE_ACCEPTED_TYPES)[number];

export type TaxonomyIconMimeType =
  (typeof TAXONOMY_ICON_ACCEPTED_TYPES)[number];

const EXTENSION_BY_MIME: Record<ArticleCoverImageMimeType, string> = {
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/webp": "webp",
  "image/gif": "gif",
};

export function isAcceptedCoverImageType(
  mimeType: string,
): mimeType is ArticleCoverImageMimeType {
  return (ARTICLE_COVER_IMAGE_ACCEPTED_TYPES as readonly string[]).includes(
    mimeType,
  );
}

export function isAcceptedTaxonomyIconType(
  mimeType: string,
): mimeType is TaxonomyIconMimeType {
  return (TAXONOMY_ICON_ACCEPTED_TYPES as readonly string[]).includes(mimeType);
}

export function getCoverImageExtension(mimeType: ArticleCoverImageMimeType): string {
  return EXTENSION_BY_MIME[mimeType];
}

export type UploadMediaResult =
  | { success: true; publicUrl: string }
  | { success: false; error: string };
